import styled from "styled-components";
import { defaultBreakpoints } from "styled-media-query";

export const Item = styled.p`
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  text-align: left;
  text-transform: capitalize;
  cursor: pointer;
  margin: 13px 0;  
  :hover {
    text-decoration: underline;
    color: ${({ theme }) => theme.default.color.primary};
  }
  &:last-child {
    margin-bottom: 20px;
  }
`;

export const Wrapper = styled.div`
  @media (max-width: ${defaultBreakpoints.medium}) {
    column-gap: 10px;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    z-index: 10;
  }
`;
